/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Polite_Level_Elk_AffirmInputs */

const fr_polite_level_elk_affirm = /** @type {(inputs: Polite_Level_Elk_AffirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date d'expiration`)
};

/**

* @param {Polite_Level_Elk_AffirmInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const polite_level_elk_affirm = /** @type {((inputs?: Polite_Level_Elk_AffirmInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Polite_Level_Elk_AffirmInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_polite_level_elk_affirm(inputs)
});